module.exports = __webpack_public_path__ + "img/semicircle-right.ed91516a.svg";